var $b1a42b39176dd45a$exports = {};
$b1a42b39176dd45a$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$b1a42b39176dd45a$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
